import get from 'transmute/get';
export const getIndexedAsyncAssignmentStatuses = get('assignmentStatuses');